/* MenoGlow – WordPress-Blog Client (JSONP, kein CORS nötig)
   Quelle: https://menoglow.de/wp/wp-json/wp/v2  – Port von src/lib/wordpress.ts,
   src/pages/Blog.tsx, src/pages/BlogPost.tsx, src/components/BlogTeaser.tsx */
(function () {
  'use strict';
  var API = (window.MG_WP_API && String(window.MG_WP_API).replace(/\/+$/, '')) || 'https://menoglow.de/wp/wp-json/wp/v2';
  var BLOG_URL = '/pages/blog';
  var FALLBACK_IMG = (typeof window.MG_WP_FALLBACK_IMG === 'string' && window.MG_WP_FALLBACK_IMG) || '';
  var seq = 0;

  function jsonp(path) {
    return new Promise(function (resolve, reject) {
      var cb = 'mgwp' + (++seq) + '_' + Date.now();
      var s = document.createElement('script');
      var done = false;
      var timer = setTimeout(function () { finish(null, new Error('timeout')); }, 15000);
      function finish(data, err) {
        if (done) return; done = true;
        clearTimeout(timer);
        try { delete window[cb]; } catch (e) { window[cb] = undefined; }
        if (s.parentNode) s.parentNode.removeChild(s);
        if (err) reject(err); else resolve(data);
      }
      window[cb] = function (d) { finish(d, null); };
      s.onerror = function () { finish(null, new Error('network')); };
      s.src = API + path + (path.indexOf('?') > -1 ? '&' : '?') + '_jsonp=' + cb;
      document.head.appendChild(s);
    });
  }

  var categoryColors = {
    'Wissen': 'bg-[hsl(280,30%,92%)] text-[hsl(280,40%,35%)]',
    'Wirkung': 'bg-[hsl(330,35%,90%)] text-[hsl(330,50%,30%)]',
    'Wärme': 'bg-[hsl(350,40%,91%)] text-[hsl(350,45%,32%)]',
    'Glow': 'bg-[hsl(310,30%,90%)] text-[hsl(310,40%,33%)]',
    'Körper': 'bg-[hsl(290,25%,88%)] text-[hsl(290,35%,30%)]',
    'Lifestyle': 'bg-[hsl(320,28%,91%)] text-[hsl(320,38%,32%)]',
    'Mental Health': 'bg-[hsl(270,30%,90%)] text-[hsl(270,40%,33%)]',
    'Produkte': 'bg-[hsl(340,30%,91%)] text-[hsl(340,40%,30%)]',
    'Community': 'bg-[hsl(300,25%,89%)] text-[hsl(300,35%,32%)]',
    'Beschwerden': 'bg-[hsl(345,35%,90%)] text-[hsl(345,45%,30%)]'
  };
  function catCls(c) { return categoryColors[c] || 'bg-muted text-foreground'; }

  var MONTHS = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function stripHtml(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return d.textContent || d.innerText || ''; }
  function readingTime(html) {
    var t = stripHtml(html).trim();
    var w = t ? t.split(/\s+/).length : 0;
    return Math.max(1, Math.round(w / 200)) + (L.minutes || ' Min.');
  }
  function fmtDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.getDate() + '. ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function normalize(wp) {
    var emb = wp._embedded || {};
    var fm = (emb['wp:featuredmedia'] && emb['wp:featuredmedia'][0]) || null;
    var image = '';
    if (fm) {
      var sizes = (fm.media_details && fm.media_details.sizes) || {};
      var pick = sizes.medium_large || sizes.large || sizes.full;
      image = (pick && pick.source_url) || fm.source_url || '';
    }
    var contentHtml = (wp.content && wp.content.rendered) || '';
    if (!image) { var m = contentHtml.match(/<img[^>]+src=["']([^"']+)["']/); if (m) image = m[1]; }
    if (!image) image = FALLBACK_IMG;
    var cats = (emb['wp:term'] && emb['wp:term'][0] ? emb['wp:term'][0].map(function (t) { return t.name; }) : []);
    var fb = contentHtml.match(/<!--\s*freebie:\s*([\w-]+)\s*-->/);
    return {
      slug: wp.slug,
      title: stripHtml((wp.title && wp.title.rendered) || ''),
      excerpt: stripHtml((wp.excerpt && wp.excerpt.rendered) || '').trim(),
      date: fmtDate(wp.date),
      author: 'Mara',
      category: cats[0] || 'Wissen',
      categories: cats,
      readingTime: readingTime(contentHtml),
      image: image,
      contentHtml: contentHtml,
      freebie: fb ? fb[1] : undefined
    };
  }

  var _postsPromise = null;
  function getPosts() {
    if (!_postsPromise) {
      _postsPromise = jsonp('/posts?per_page=100&_embed&orderby=date&order=desc')
        .then(function (d) { return (Array.isArray(d) ? d : []).map(normalize); })
        .catch(function () { return []; });
    }
    return _postsPromise;
  }
  function getPinnedSlug() {
    return jsonp('/tags?slug=menoglow-pinned')
      .then(function (tags) {
        if (!Array.isArray(tags) || !tags.length) return null;
        return jsonp('/posts?tags=' + tags[0].id + '&per_page=1&orderby=date&order=desc&_fields=slug')
          .then(function (p) { return (Array.isArray(p) && p[0]) ? p[0].slug : null; });
      })
      .catch(function () { return null; });
  }
  function articleUrl(slug) { return BLOG_URL + '?a=' + encodeURIComponent(slug); }

  /* ---------- Kategorie-Badges (Port von BlogCategoryBadges.tsx) ---------- */
  function badges(cats, maxHeight) {
    var h = maxHeight || 20;
    var inner = cats.map(function (c) {
      return '<span class="inline-block whitespace-nowrap px-2 py-0.5 rounded-full text-[0.6rem] font-medium ' + catCls(c) + '">' + esc(c) + '</span>';
    }).join('');
    return '<div class="mg-badges flex flex-wrap gap-1 mb-1.5 overflow-hidden" data-mh="' + h + '" style="max-height:' + h + 'px">' + inner + '</div>';
  }
  function trimBadges(scope) {
    (scope || document).querySelectorAll('.mg-badges').forEach(function (el) {
      var mh = parseInt(el.getAttribute('data-mh') || '20', 10);
      var kids = Array.prototype.slice.call(el.children).filter(function (c) { return !c.classList.contains('mg-ell'); });
      if (!kids.length) return;
      var top = el.getBoundingClientRect().top, count = 0;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].getBoundingClientRect().top - top < mh) count++; else break;
      }
      if (count < kids.length && count > 0) count = count - 1;
      if (count >= kids.length) return;
      kids.forEach(function (k, i) { if (i >= count) k.remove(); });
      var e = document.createElement('span');
      e.className = 'mg-ell inline-block whitespace-nowrap px-2 py-0.5 rounded-full text-[0.6rem] font-medium bg-muted text-foreground';
      e.textContent = '…';
      el.appendChild(e);
    });
  }

  function skel(cls) { return '<div class="animate-pulse rounded-md bg-muted ' + cls + '"></div>'; }

  /* ---------- Home-Teaser (Port von BlogTeaser.tsx) ---------- */
  function teaserCard(p) {
    return '<a href="' + articleUrl(p.slug) + '" class="group block rounded-3xl overflow-hidden glass-card hover:shadow-elevated transition-all duration-500">' +
      '<div class="aspect-[16/10] overflow-hidden"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"></div>' +
      '<div class="p-6 space-y-3">' +
      '<span class="inline-block text-xs font-medium px-3 py-1 rounded-full ' + catCls(p.category) + '">' + esc(p.category) + '</span>' +
      '<h3 class="font-display text-lg font-semibold text-foreground group-hover:text-primary transition-colors line-clamp-2">' + esc(p.title) + '</h3>' +
      '<p class="font-body text-sm text-muted-foreground line-clamp-2">' + esc(p.excerpt) + '</p>' +
      '<span class="font-body text-xs text-muted-foreground">' + esc(p.readingTime) + ' ' + (L.reading_time || 'Lesezeit') + '</span>' +
      '</div></a>';
  }
  function initTeaser(root) {
    root.innerHTML = [0, 1, 2].map(function () {
      return '<div class="rounded-3xl overflow-hidden glass-card">' + skel('aspect-[16/10] w-full') +
        '<div class="p-6 space-y-3">' + skel('h-5 w-20 rounded-full') + skel('h-6 w-full') + skel('h-4 w-3/4') + '</div></div>';
    }).join('');
    getPosts().then(function (posts) {
      if (!posts.length) { root.innerHTML = '<p class="font-body text-muted-foreground text-center md:col-span-3">' + (L.empty_teaser || 'Aktuell sind keine Beiträge verfügbar.') + '</p>'; return; }
      root.innerHTML = posts.slice(0, 3).map(teaserCard).join('');
    });
  }

  /* ---------- Blog-Übersicht (Port von Blog.tsx) ---------- */
  function bigCard(p, pinned) {
    var italic = /^\s*<h2/.test(p.contentHtml || '') ? ' italic' : '';
    return '<a href="' + articleUrl(p.slug) + '" class="group block h-full">' +
      '<article class="rounded-2xl overflow-hidden border shadow-soft hover:shadow-lg transition-shadow duration-500 h-full flex flex-col ' +
      (pinned ? 'bg-primary/5 border-primary/20' : 'bg-card border-border/50') + '">' +
      '<div class="aspect-[16/9] overflow-hidden"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"></div>' +
      '<div class="p-4 flex flex-col flex-1">' + badges(p.categories.length ? p.categories : [p.category], 24) +
      '<h3 class="font-display text-sm font-semibold text-foreground mb-1 group-hover:text-primary transition-colors line-clamp-2">' + esc(p.title) + '</h3>' +
      '<p class="font-body text-xs text-muted-foreground mb-2 leading-relaxed flex-1 line-clamp-2' + italic + '">' + esc(p.excerpt) + '</p>' +
      '<span class="font-body text-[0.65rem] text-muted-foreground">' + esc(p.date) + ' · ' + esc(p.readingTime) + '</span>' +
      '</div></article></a>';
  }
  function smallCard(p) {
    var italic = /^\s*<h2/.test(p.contentHtml || '') ? ' italic' : '';
    return '<a href="' + articleUrl(p.slug) + '" class="group block h-full">' +
      '<article class="bg-card rounded-2xl overflow-hidden border border-border/50 shadow-soft hover:shadow-lg transition-shadow duration-500 h-full flex flex-col">' +
      '<div class="aspect-[16/10] overflow-hidden"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"></div>' +
      '<div class="p-3 flex flex-col flex-1">' + badges(p.categories.length ? p.categories : [p.category], 26) +
      '<h3 class="font-display text-xs font-semibold text-foreground mb-1 group-hover:text-primary transition-colors line-clamp-2">' + esc(p.title) + '</h3>' +
      '<p class="font-body text-[0.65rem] text-muted-foreground leading-relaxed flex-1 line-clamp-2' + italic + '">' + esc(p.excerpt) + '</p>' +
      '<span class="font-body text-[0.6rem] text-muted-foreground mt-1.5">' + esc(p.readingTime) + '</span>' +
      '</div></article></a>';
  }

  var ALL_POSTS = [], PINNED = null, ACTIVE = null, LISTROOT = null;

  function renderList() {
    if (!LISTROOT) return;
    var posts = ALL_POSTS;
    var filtered = ACTIVE ? posts.filter(function (p) { return p.categories.indexOf(ACTIVE) > -1 || p.category === ACTIVE; }) : posts;
    var html = '';

    var all = [];
    posts.forEach(function (p) {
      (p.categories.length ? p.categories : [p.category]).forEach(function (c) { if (all.indexOf(c) === -1) all.push(c); });
    });
    if (all.length > 1) {
      var btn = function (label, active, val) {
        return '<button type="button" data-cat="' + esc(val === null ? '' : val) + '" class="px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ' +
          (active ? 'bg-primary text-primary-foreground shadow-md' : 'bg-card border border-border/50 text-muted-foreground hover:text-foreground hover:border-primary/30') + '">' + esc(label) + '</button>';
      };
      html += '<section class="px-2 md:px-6 pb-3"><div class="container mx-auto max-w-5xl">' +
        '<div class="flex flex-wrap justify-center gap-2 animate-fade-up">' + btn((L.all_categories || 'Alle'), ACTIVE === null, null) +
        all.map(function (c) { return btn(c, ACTIVE === c, c); }).join('') + '</div></div></section>';
    }

    if (!filtered.length) {
      html += '<section class="px-2 md:px-6 pb-24 text-center"><p class="font-body text-muted-foreground text-lg">' + (L.empty_category || 'Noch keine Beiträge in dieser Kategorie – bald mehr!') + '</p></section>';
      LISTROOT.innerHTML = html; bindFilter(); return;
    }

    var pinnedPost = PINNED ? filtered.filter(function (p) { return p.slug === PINNED; })[0] : null;
    var others = filtered.filter(function (p) { return !pinnedPost || p.slug !== pinnedPost.slug; });
    var topRow = (pinnedPost ? [pinnedPost] : []).concat(others.slice(0, pinnedPost ? 2 : 3));
    var rest = filtered.filter(function (p) { return !topRow.some(function (t) { return t.slug === p.slug; }); });

    if (!ACTIVE && topRow.length) {
      html += '<section class="px-2 md:px-6 pb-6"><div class="container mx-auto max-w-5xl">' +
        '<div class="grid gap-5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">' +
        topRow.map(function (p) { return '<div class="animate-fade-up">' + bigCard(p, p.slug === PINNED) + '</div>'; }).join('') +
        '</div></div></section>';
    }
    var listPosts = ACTIVE ? filtered : rest;
    if (listPosts.length) {
      html += '<section class="px-2 md:px-6 pb-24"><div class="container mx-auto max-w-5xl">' +
        '<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5">' +
        listPosts.map(function (p) { return '<div class="animate-fade-up">' + smallCard(p) + '</div>'; }).join('') +
        '</div></div></section>';
    }
    LISTROOT.innerHTML = html;
    bindFilter();
    requestAnimationFrame(function () { trimBadges(LISTROOT); });
  }
  function bindFilter() {
    LISTROOT.querySelectorAll('button[data-cat]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-cat');
        ACTIVE = (!v || v === ACTIVE) ? null : v;
        renderList();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }
  function listSkeleton() {
    return '<section class="px-2 md:px-6 pb-24"><div class="container mx-auto max-w-5xl">' +
      '<div class="grid md:grid-cols-2 gap-8 bg-card rounded-3xl overflow-hidden border border-border/50 p-8">' +
      skel('aspect-[4/3] w-full rounded-2xl') +
      '<div class="space-y-4">' + skel('h-6 w-24 rounded-full') + skel('h-10 w-full') + skel('h-4 w-3/4') + skel('h-4 w-1/2') + '</div>' +
      '</div></div></section>';
  }

  /* ---------- Freebie-CTA (Port von BlogFreebieCTA.tsx) ---------- */
  var L = window.MG_WP_LABELS || {};
  var FREEBIES = {
    'koerper-check': { title: 'Mach den MenoGlow Körper-Check', description: 'Finde in 3 Minuten heraus, in welcher hormonellen Phase Du gerade bist – und was Dein Körper jetzt braucht.', buttonText: 'Jetzt starten', link: '/pages/koerper-check', gradient: 'gradient-berry', buttonStyle: 'bg-primary-foreground text-primary' },
    'kollagen': { title: 'MenoGlow Kollagen entdecken', description: '12.500 mg marines Kollagen, Hyaluronsäure & Vitamin C – speziell für Frauen ab 40. Mit Vitamin C, das zu einer normalen Kollagenbildung für die normale Funktion von Haut, Knochen und Knorpel beiträgt – für deinen MenoGlow.', buttonText: 'Mehr erfahren', link: '/pages/kollagen', gradient: 'bg-gradient-to-br from-[hsl(34_42%_84%)] to-[hsl(330_64%_33%/0.85)]', buttonStyle: 'bg-primary-foreground text-primary' },
    'workbook': { title: 'MenoGlow Workbook', description: 'Dein persönliches Workbook für die Wechseljahre – mit Reflexionsübungen, Checklisten und Impulsen für jeden Tag.', buttonText: 'Jetzt herunterladen', modal: 'wp-workbook', link: '/pages/freebie-workbook', gradient: 'bg-gradient-to-br from-[hsl(330_64%_33%)] to-[hsl(265_42%_58%)]', buttonStyle: 'bg-primary-foreground text-accent' },
    'newsletter': { title: 'Werde Teil der MenoGlow Community', description: 'Wöchentliche Impulse, exklusive Inhalte und Austausch mit Frauen, die verstehen, was du durchmachst.', buttonText: 'Jetzt anmelden', modal: 'newsletter', link: '/pages/freebies', gradient: 'gradient-berry-dark', buttonStyle: 'bg-primary-foreground text-primary' },
    'ernaehrungsplan': { title: 'Hol Dir Deinen Glow-Ernährungsplan', description: 'Weniger Rätselraten. Mehr Klarheit, was dir wirklich gut tut. Ein 3-Tage-Plan, der dir zeigt, wie Ernährung sich anfühlen kann: stabil, nährend, ruhig. Mit Rezepten, Struktur und echten Alltagstipps.', buttonText: 'Hier gehts zum Glow-Plan', modal: 'wp-ernaehrungsplan', link: '/pages/freebie-ernaehrungsplan', gradient: 'bg-gradient-to-br from-[hsl(342_58%_31%)] via-[hsl(323_42%_38%)] to-[hsl(286_28%_44%)]', buttonStyle: 'bg-primary-foreground text-primary' },
    'symptom-tracker': { title: 'MenoGlow Symptom-Tracker', description: 'Behalte den Überblick über Deine Symptome – erkenne Muster und sprich fundiert mit Deiner Ärztin.', buttonText: 'Tracker starten', link: '/pages/freebies', gradient: 'bg-gradient-to-br from-[hsl(228_42%_86%)] to-[hsl(230_55%_35%)]', buttonStyle: 'bg-primary-foreground text-[hsl(230_55%_35%)]' },
    'hormonguide': { title: 'Der große Hormon-Guide', description: 'Alles, was Du über Östrogen, Progesteron & Co. wissen musst – verständlich erklärt, medizinisch fundiert.', buttonText: 'Guide holen', modal: 'wp-hormonguide', link: '/pages/freebie-hormonguide', gradient: 'bg-gradient-to-br from-[hsl(330_64%_33%)] to-[hsl(265_50%_38%)]', buttonStyle: 'bg-primary-foreground text-primary' }
  };
  if (window.MG_WP_FREEBIES) {
    Object.keys(window.MG_WP_FREEBIES).forEach(function (k) {
      var o = window.MG_WP_FREEBIES[k];
      FREEBIES[k] = FREEBIES[k] || {};
      Object.keys(o).forEach(function (p) { if (o[p] !== '' && o[p] !== null && o[p] !== undefined) FREEBIES[k][p] = o[p]; });
    });
  }
  function freebieCTA(slug) {
    var c = FREEBIES[slug] || FREEBIES['koerper-check'];
    var cls = 'inline-block px-8 py-3 rounded-full font-body font-medium hover:opacity-90 transition-opacity ' + c.buttonStyle;
    var btn = (c.modal && document.getElementById('mg-modal-' + c.modal))
      ? '<button type="button" data-mgwp-modal="' + c.modal + '" class="' + cls + '">' + esc(c.buttonText) + '</button>'
      : '<a href="' + c.link + '" class="' + cls + '">' + esc(c.buttonText) + '</a>';
    return '<div class="p-6 md:p-8 rounded-3xl text-center animate-fade-up ' + c.gradient + '">' +
      '<h3 class="font-display text-2xl text-primary-foreground mb-3">' + esc(c.title) + '</h3>' +
      '<p class="font-body text-primary-foreground/80 mb-6 max-w-md mx-auto">' + esc(c.description) + '</p>' + btn + '</div>';
  }
  function openModal(name) {
    if (window.mgOpenModal) { window.mgOpenModal(name); return; }
    var m = document.getElementById('mg-modal-' + name);
    if (!m) return;
    m.classList.remove('hidden'); m.classList.add('flex');
    document.body.style.overflow = 'hidden';
  }

  var PATHMAP = {
    '/koerper-check': '/pages/koerper-check', '/kollagen': '/pages/kollagen',
    '/produkt/kollagen': '/pages/produkt-kollagen', '/ueber-uns': '/pages/ueber-uns',
    '/faq': '/pages/faq', '/freebies': '/pages/freebies', '/app': '/pages/app',
    '/kurs': '/pages/online-kurs', '/online-kurs': '/pages/online-kurs',
    '/impressum': '/pages/impressum', '/datenschutz': '/pages/datenschutz',
    '/agb': '/pages/agb', '/widerruf': '/pages/widerruf', '/versand': '/pages/versand',
    '/blog': BLOG_URL,
    '/freebie/hormonguide': '/pages/freebie-hormonguide',
    '/freebie/workbook': '/pages/freebie-workbook',
    '/freebie/ernaehrungsplan': '/pages/freebie-ernaehrungsplan',
    '/freebie/ernaehungsplan': '/pages/freebie-ernaehrungsplan',
    '/freebie/koerpercheck': '/pages/koerper-check',
    '/freebie/koerper-check': '/pages/koerper-check'
  };
  function mapPath(href) {
    if (!href) return null;
    var m = href.match(/^(?:https?:\/\/(?:www\.)?menoglow\.de)?(\/[^?#]*)([?#].*)?$/i);
    if (!m) return null;
    var p = m[1].replace(/\/+$/, '') || '/';
    var rest = m[2] || '';
    var art = p.match(/^\/(?:blog|wp)\/([^\/]+)$/);
    if (art) return articleUrl(art[1]);
    if (PATHMAP[p]) return PATHMAP[p] + rest;
    if (p === '/') return '/' + rest;
    return null;
  }
  function fixLinks(scope) {
    scope.querySelectorAll('a[href]').forEach(function (a) {
      var t = mapPath(a.getAttribute('href'));
      if (t) { a.setAttribute('href', t); a.removeAttribute('target'); }
    });
  }

  /* ---------- Einzelartikel (Port von BlogPost.tsx) ---------- */
  function articleSkeleton() {
    return '<div class="pt-20 container mx-auto max-w-4xl px-6">' + skel('h-8 w-40 mt-8 mb-8') + skel('rounded-3xl aspect-[21/9] w-full') +
      '<div class="max-w-3xl mx-auto py-12 space-y-4">' + skel('h-6 w-24 rounded-full') + skel('h-12 w-full') + skel('h-4 w-1/3') + skel('h-4 w-full mt-8') + skel('h-4 w-full') + skel('h-4 w-3/4') + '</div></div>';
  }
  function renderArticle(root, post, others) {
    var cats = post.categories.length ? post.categories : [post.category];
    var html = '<div class="pt-20 animate-fade-in"><div class="container mx-auto max-w-4xl px-6 pt-8">' +
      '<a href="' + BLOG_URL + '" class="inline-flex items-center gap-2 font-body text-sm text-muted-foreground hover:text-primary transition-colors mb-8">' +
      '<i data-lucide="arrow-left" class="w-4 h-4"></i> Zurück zum Blog</a></div></div>' +
      '<article class="container mx-auto max-w-3xl px-6 pt-0 pb-12"><div class="animate-fade-up">' +
      '<div class="flex gap-6 mb-3">' +
      (post.image ? '<div class="w-28 h-28 md:w-36 md:h-36 flex-shrink-0 rounded-2xl overflow-hidden"><img src="' + esc(post.image) + '" alt="' + esc(post.title) + '" class="w-full h-full object-cover"></div>' : '') +
      '<div class="flex flex-col justify-center"><div class="flex flex-wrap gap-1.5 mb-3">' +
      cats.map(function (c) { return '<span class="inline-block px-3 py-1 rounded-full text-xs font-medium ' + catCls(c) + '">' + esc(c) + '</span>'; }).join('') +
      '</div><h1 class="font-display text-2xl md:text-4xl font-light text-foreground leading-tight">' + esc(post.title) + '</h1></div></div>' +
      '<div class="flex items-center gap-6 font-body text-sm text-muted-foreground mb-4 pb-4 border-b border-border">' +
      '<span class="flex items-center gap-1.5"><i data-lucide="user" class="w-4 h-4"></i> ' + esc(post.author) + '</span>' +
      '<span>' + esc(post.date) + '</span>' +
      '<span class="flex items-center gap-1.5"><i data-lucide="clock" class="w-4 h-4"></i> ' + esc(post.readingTime) + '</span></div>' +
      '<div class="wp-content max-w-none">' + post.contentHtml + '</div></div>' +
      freebieCTA(post.freebie);
    if (others.length) {
      html += '<div class="mt-20"><h3 class="font-display text-2xl text-foreground mb-8">Weiterlesen</h3>' +
        '<div class="grid md:grid-cols-2 gap-6">' + others.map(function (p) {
          return '<a href="' + articleUrl(p.slug) + '" class="group"><article class="bg-card rounded-2xl overflow-hidden border border-border/50 shadow-soft hover:shadow-lg transition-shadow">' +
            '<div class="aspect-[16/9] overflow-hidden"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"></div>' +
            '<div class="p-5"><h4 class="font-display text-lg text-foreground group-hover:text-primary transition-colors mb-2">' + esc(p.title) + '</h4>' +
            '<span class="font-body text-xs text-muted-foreground">' + esc(p.date) + ' · ' + esc(p.readingTime) + '</span></div></article></a>';
        }).join('') + '</div></div>';
    }
    html += '</article>';
    root.innerHTML = html;
    document.title = post.title + ' – MenoGlow';
    var wc = root.querySelector('.wp-content'); if (wc) fixLinks(wc);
    if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
    root.querySelectorAll('[data-mgwp-modal]').forEach(function (b) {
      b.addEventListener('click', function () { openModal(b.getAttribute('data-mgwp-modal')); });
    });
    if (window.mgReveal) window.mgReveal();
  }

  /* ---------- Init ---------- */
  function initBlog(root) {
    var hero = document.getElementById('mg-wp-hero');
    var params = new URLSearchParams(window.location.search);
    var slug = params.get('a') || params.get('post') || '';
    if (slug) {
      if (hero) hero.style.display = 'none';
      root.innerHTML = articleSkeleton();
      getPosts().then(function (posts) {
        var post = posts.filter(function (p) { return p.slug === slug; })[0];
        if (!post) { window.location.replace(BLOG_URL); return; }
        renderArticle(root, post, posts.filter(function (p) { return p.slug !== post.slug; }).slice(0, 2));
      });
      return;
    }
    LISTROOT = root;
    root.innerHTML = listSkeleton();
    Promise.all([getPosts(), getPinnedSlug()]).then(function (r) {
      ALL_POSTS = r[0]; PINNED = r[1];
      if (!ALL_POSTS.length) {
        root.innerHTML = '<section class="px-2 md:px-6 pb-24 text-center"><p class="font-body text-muted-foreground text-lg">Die Beiträge konnten gerade nicht geladen werden. Bitte lade die Seite neu.</p></section>';
        return;
      }
      renderList();
    });
  }

  function boot() {
    var t = document.getElementById('mg-wp-teaser');
    if (t) initTeaser(t);
    var b = document.getElementById('mg-wp-root');
    if (b) initBlog(b);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.MGWP = { getPosts: getPosts, articleUrl: articleUrl, categoryColors: categoryColors };
})();
